const normalizeRows = (rows, nameKeys) =>
  Array.isArray(rows)
    ? rows
        .map((row, index) => {
          const value =
            nameKeys.reduce((currentValue, key) => currentValue ?? row?.[key], null) ??
            row?.description ??
            row?.name ??
            row?.displayName ??
            row?.id ??
            "";

          return {
            ...row,
            id: String(row?.id ?? index).trim(),
            description: String(value ?? "").trim(),
          };
        })
        .filter((row) => row.description)
    : [];



const pickQuickBooksRows = (payload, keys) => {
  if (Array.isArray(payload)) return payload;
  if (!payload || typeof payload !== "object") return [];

  for (const key of keys) {
    if (Array.isArray(payload[key])) return payload[key];
  }

  return Object.values(payload).find(Array.isArray) || [];
};

export const normalizeQuickBooksAccountList = (payload) =>
  pickQuickBooksRows(payload, ["accounts", "account_list", "accountList", "data", "rows", "result", "results", "list"])
    .map((row) => {
      const id =
        row?.id ??
        row?.account_id ??
        row?.accountid ??
        row?.qb_account_id ??
        row?.account_number ??
        row?.accountNumber ??
        row?.account ??
        row?.code ??
        row?.value ??
        "";
      const description =
        row?.description ??
        row?.account_description ??
        row?.accountDescription ??
        row?.account_name ??
        row?.accountName ??
        row?.name ??
        row?.display_name ??
        row?.displayName ??
        row?.fully_qualified_name ??
        row?.fullyQualifiedName ??
        row?.label ??
        id;

      return {
        ...row,
        id: String(id ?? "").trim(),
        description: String(description ?? "").trim(),
      };
    })
    .filter((row) => row.id || row.description);

export const normalizeQuickBooksClassDepartmentList = (payload) => {
  if (Array.isArray(payload)) {
    return {
      classes: normalizeRows(payload, ["class_name"]),
      departments: [],
    };
  }

  return {
    classes: normalizeRows(payload?.classes, ["class_name"]),
    departments: normalizeRows(payload?.departments, ["department_name"]),
  };
};
